let toastBody = null

function showToast(text) {
    if (toastBody) {
        document.body.removeChild(toastBody)
        toastBody = null
    }
    toastBody = document.createElement("div");
    toastBody.classList.add('sl-toast');
    toastBody.innerText = text
    document.body.append(toastBody)
    const timeoutID = window.setTimeout(() => {
        if (toastBody) {
            document.body.removeChild(toastBody)
            toastBody = null
        }
        window.clearTimeout(timeoutID)
    }, 3000);
}

module.exports = {
    showToast,
}